<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <h3>Czy na pewno chcesz zmienić status na "{{data.newStatusName}}"?
    <span *ngIf="data.newStatusName == 'Odrzucona'"><br><br>{{data.tagLine}}</span>
    </h3>
  </div>

  <div fxLayout="row" *ngIf="data.enableNote">
    <mat-form-field fxFlex="100">
      <mat-label>{{data.noteLabel}}</mat-label>
      <textarea [formControl]="noteControl" matInput [placeholder]="data.noteLabel"></textarea>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button [disabled]="processingRequest || !changeStatusForm.valid" (click)="sendForm()" mat-raised-button color="warn"><span> Tak</span></button>
    </div>
    <div>
      <button (click)="closeDialog($event)" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> Nie</span></button>
    </div>
  </div>
</div>
